import { Injectable } from '@angular/core';
import { DataService } from '../data/data.service';
import { Observable } from 'rxjs';
import { User } from '@xanadu/model';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    constructor(private dataService: DataService) { }

    password(id: string, current: string, password: string): Observable<any> {
        return this.dataService.post(User, { _id: id, current, password }, 'password');
    }
}
